import React from 'react';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import PersonRoundedIcon from '@mui/icons-material/PersonRounded';
import LocalPharmacyRoundedIcon from '@mui/icons-material/LocalPharmacyRounded';
import TranslateRoundedIcon from '@mui/icons-material/TranslateRounded';



function Footer() {
    /*
    const [on, off] = useState(false);

const turnOnOff = () => {
    off(!on);
}
{ on ? <HomeRoundedIcon className="text-secondary" style={{ fontSize: '1.6rem' }} /> : <HomeRoundedIcon className="text-primary" style={{ fontSize: '1.6rem' }} /> }

*/
    return (
        <footer className="menu"
        style={{ position: 'fixed', bottom: 0, width: '100%', zIndex: 1000, boxShadow: '0 -1px 5px rgba(0, 0, 0, 0.2)' }}>

            <div className="menu-content bg-white text-secondary text-align-center"
            style={{ display: 'flex', justifyContent: 'space-around', padding: '10px 0' }}>
                
                <div className="menu-item text-center">
                    <HomeRoundedIcon className="text-secondary" style={{ fontSize: '1.6rem' }} />
                    <p>Inicio</p>
                </div>
                <div className="menu-item text-center">
                    <TranslateRoundedIcon className="text-primary" style={{ fontSize: '1.6rem' }} />
                    <p className='text-primary'>Traductor</p>
                </div>
                <div className="menu-item text-center">
                    <LocalPharmacyRoundedIcon className="text-secondary" style={{ fontSize: '1.6rem' }} />
                    <p>Medicamentos</p>
                </div>
                <div className="menu-item text-center">
                    <PersonRoundedIcon className="text-secondary" style={{ fontSize: '1.6rem' }} />
                    <p>Perfil</p>
                </div>
            </div>
        </footer>
    );
}

export default Footer;